import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import useCostCenters from '~/modules/common/enhancers/useCostCenters';
import { useAdditionalOptions } from '~/modules/common/hooks';
import { useOptionsMerge } from '~/modules/common/components/SearchAutocomplete';
import { useStyledGroupLabels } from './hooks';
import GroupDropdown from './GroupDropdown';

export const CostCenterDropdown = ({
  classes,
  groupSettings,
  value,
  policy,
  onChange,
  enableNoChangeOption = false,
  enableNoValueOption = false,
  ...rest
}) => {
  const { formatMessage } = useIntl();
  const [searchTerm, setSearchTerm] = useState('');
  const { costCenter: costCenterLabel } = useStyledGroupLabels();
  const { costCenters, loading, hasMore } = useCostCenters({
    searchTerm,
    policy
  });
  const additionalOptions = useAdditionalOptions({
    enableNoChangeOption,
    enableNoValueOption,
    noValueMessageId: 'dropdownItem.noCostCenter'
  });

  const noGroupsText = groupSettings.singularName
    ? formatMessage(
        { id: 'groupsDropdown.noGroup' },
        { group: groupSettings.singularName }
      )
    : formatMessage({ id: 'costCenterDropdown.noCostCenter' });

  const options = useOptionsMerge({
    options: costCenters,
    additionalOptions
  });

  return (
    <GroupDropdown
      hasMore={hasMore}
      classes={classes}
      options={options}
      label={costCenterLabel}
      value={value}
      setSearchTerm={setSearchTerm}
      loading={loading}
      noOptionsText={noGroupsText}
      onChange={onChange}
      optionTypeText={formatMessage({
        id: 'moreOptions.costCenter'
      })}
      {...rest}
    />
  );
};

CostCenterDropdown.propTypes = {
  classes: PropTypes.object,
  groupSettings: PropTypes.object,
  onChange: PropTypes.func,
  value: PropTypes.object,
  policy: PropTypes.string,
  enableNoChangeOption: PropTypes.bool,
  enableNoValueOption: PropTypes.bool
};

export default CostCenterDropdown;
